import { render, staticRenderFns } from "./CreateFreeAccount.vue?vue&type=template&id=58a1f420&scoped=true&"
import script from "./CreateFreeAccount.vue?vue&type=script&lang=js&"
export * from "./CreateFreeAccount.vue?vue&type=script&lang=js&"
import style0 from "./CreateFreeAccount.vue?vue&type=style&index=0&id=58a1f420&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a1f420",
  null
  
)

export default component.exports